<template>
  <div style="width: 100%;">
    <v-container>
      <v-row>
        <v-col class='d-flex flex-row align-center'>
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          <span class="d-flex flex-column">
            <h1>{{this.singular}}: {{this.data.name}}</h1>
          </span>
          <v-progress-circular
            indeterminate
            color="green"
            v-if="loader"
            style="margin-left: 10px;"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn @click="isEditable = !isEditable">
            <span v-if="this.isEditable">Cancel</span>
            <span v-else>Edit</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
              label="First Name"
              :disabled="!this.isEditable"
              outlined
              v-model="data.name"
          />
          <v-text-field
              label="Email"
              :disabled="!this.isEditable"
              outlined
              v-model="data.email"
          />
          <v-text-field
              label="phone"
              :disabled="!this.isEditable"
              outlined
              v-model="data.telephone"
          />

        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn v-if="isEditable" @click="update">Save</v-btn>
          <v-btn v-if="isEditable" style="margin-left: 10px;" class="error" @click="deleteData">Delete</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <span class="d-flex flex-row">
            <h2>Assets Supplied by {{data.name}}</h2>
            <v-btn class="mx-2" fab x-small color="success"><v-icon>mdi-plus</v-icon></v-btn>
          </span>
          <div v-if="data.Assets && data.Assets.length > 0">
            <v-data-table
              :headers="headers"
              :items="data.Assets"
              :items-per-page="1000000"
              class="elevation-1"
            >
            </v-data-table>
          </div>
          <div v-else>
            <i>No Assets Yet</i>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>

<script>
  import { mapGetters } from "vuex"
  import axios from 'axios';
  export default {
    data () {
      return {
        deleteDialog: false,
        deleteConfirmed: true,
        loader: true,
        snackObj: {
          color: '',
          text: ''
        },
        max25chars: v => v.length <= 25 || 'Input too long!',
        headers: [
          { text: "ID", align: "start", sortable: true, value: "id"},
          { text: 'Style No', sortable: true, value: 'styleNo' },
        ],
        editMode: false,
        data: {metadata: {sIdToken: ''}},
        singular: "Supplier",
        singularLower: "supplier",
        plural: "Suppliers",
        pluralLower: "suppliers",
        isEditable: false,
        userTypes: [],
        resetPassDialog: {
          open: false,
          adminPass: '',
          newPass: '',
        },
        registeredDevices: [],
      }
    },
    async mounted(){
        try {
          let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
          this.data = res.data
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false;
        }
    },
    computed: {
      ...mapGetters(['getUser', 'getId', 'getEndpoint'])
    },
    methods: {
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.color = color;

        this.$refs.snackbar.openDialog();
      },
      async update(){
        try {
          this.loader = true;
          let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`, this.data)
          console.log(res);
          if(res.data.success){
            this.snack(`${this.singular} info Updated 🎉`, "success")
            this.isEditable = false;
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false;
        }
      },
      async unsuspend(){
        try {
          this.loader = true;          
          let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/unsuspend/${this.$route.params.id}`, this.data)
          console.log(res);
          if(res.data.success){
            this.snack(`Account Unsuspended 🎉`, "success");
            this.isEditable = false;
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false;
        }
      },
      async deleteData(){
        try {
          this.loader = true
          let res = await axios.delete(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
          if(res.status == 200){
            this.snack(this.singular+" Deleted 🎉", "success");
            setTimeout(()=>{
              this.$router.push({ path: `/${this.pluralLower}`})
            }, 1000)
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },
      openResetPassDialog(){
        this.resetPassDialog.open = true;
      },
      closeResetPassDialog(){
        this.resetPassDialog.open = false;
        this.openResetPassDialog.adminPass = ''
        this.openResetPassDialog.newPass = ''
      },
      async resetPass(){
        try {
          let data = this.resetPassDialog
          data.adminId = this.getId
          console.log(data)
          let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/editPassword/${this.$route.params.id}`, data)
          if(!res) throw "Error. Perhaps it is your password."
          if(res.data.success){
            this.snack("Password Updated", "success")
            this.closeResetPassDialog()
          }else throw "Password not updated"
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },
      //superadmin only
      async forceLogout(){
        try {
          let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}/forceLogout/${this.$route.params.id}`)
          if(res.status == 200){
            this.snack("User Logged Out 🎉", "success");
            this.data.isLoggedIn = false
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },
      async resetSecureIdToken(){
        try {
          let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}/resetSecureIdToken/`, {uId: this.$route.params.id})
          if(res.status == 200){
            this.snack("SID Created", "success")
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      }
    }
  }
</script>
